import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { handleGoogleCallback } = useAuth();
  const [status, setStatus] = useState('Signing you in...');
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    const processAuth = async () => {
      // Extract session_id from URL - try multiple methods
      const hash = window.location.hash || '';
      const fullUrl = window.location.href;
      
      let sessionId = null;
      const hashMatch = hash.match(/session_id=([^&]+)/);
      if (hashMatch) sessionId = hashMatch[1];
      if (!sessionId) {
        const urlMatch = fullUrl.match(/session_id=([^&]+)/);
        if (urlMatch) sessionId = urlMatch[1];
      }

      if (!sessionId) {
        setStatus('Session not found. Redirecting...');
        setTimeout(() => navigate('/auth', { replace: true }), 1000);
        return;
      }

      try {
        await handleGoogleCallback(sessionId);
        setStatus('Success! Welcome aboard...');
        // Short delay then navigate via React Router (no page reload)
        setTimeout(() => navigate('/dashboard', { replace: true }), 300);
      } catch (err) {
        console.error('Google auth callback error:', err);
        setStatus('Sign-in failed. Redirecting...');
        setTimeout(() => navigate('/auth', { replace: true }), 1500);
      }
    };

    processAuth();

    // Safety net: 12 seconds max on this page
    const safety = setTimeout(() => {
      navigate('/auth', { replace: true });
    }, 12000);

    return () => clearTimeout(safety);
  }, [navigate, handleGoogleCallback]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[#C6A87C] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p style={{ color: '#666666' }}>{status}</p>
      </div>
    </div>
  );
};

export default AuthCallback;
